import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.300',
    endColor: 'alpha.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    bg: 'blackAlpha.500',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: 'base',
    color: 'white',
    mb: '0',
    border: 'none',
    fontFamily: 'accent',
    _hover: {
      '&&': {
        _placeholder: {
          color: 'gray.400',
        },
      },
      color: 'white',
    },
    _focus: {
      '&&': {
        bg: 'blackAlpha.400',
        _placeholder: {
          color: 'gray.400',
        },
      },
      color: 'beta.500',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.700',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
    sx: {
      '&&': {
        bg: 'blackAlpha.400',
        _placeholder: {
          color: 'whiteAlpha.400',
        },
      },
    },
  },
  inputRightIcon: {
    color: 'beta.300',
    boxSize: '4',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: {
    alignItems: 'center',
    gap: 2,
    flex: 1,
    textAlign: 'left',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  accordionButtonIconSvg: {
    color: 'beta.300',
    fontSize: 'md',
  },
  accordionButtonText: {
    fontSize: 'sm',
    fontWeight: 'bold',
    color: 'beta.300',
    fontFamily: 'accent',
    textTransform: 'uppercase',
    textShadow: '0px 0px 8px rgba(255, 210, 123, 0.5)',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'white',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'beta.300',
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
